// MobileGoldenAwards.js fetches its questions via getGeneralQuestions()
// and submits answers via submitGeneralAnswer() below.
// getGoldenAwardResults further down is still speculative — not wired in.

import axios from "axios";
import constant from "../utilities/constants.json";
import { setSiteUnderMaintenanceOutsideReact } from "../utilities/reducer";

const url = constant.server;

/**
 * Fetches the current set of "Bonus Questions", including (once the user
 * is logged in) their existing answers.
 *
 * @param {{}} data
 * @returns {Promise<{
 *   data: {
 *     status: 1 | 101 | 102 | 103,
 *     message: string,
 *     data: Array<{
 *       _id: string,
 *       question: string,
 *       que_malayalam: string,
 *       que_type: number,
 *       que_answer_option: string[],
 *       end_date: string, // "YYYY-MM-DD HH:mm:ss"
 *       prediction_open: boolean,
 *       answer_updated: number,
 *       que_answer: string | null,
 *       user_answer: string | null,
 *       winners: Array<unknown>
 *     }>
 *   }
 * }>}
 */
export const getGeneralQuestions = (data) => {
  return axios
    .post(url + "general_questions", data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + `${localStorage.webKey}`,
      },
    })
    .then((response) => {
      if (response.data.status === 1) {
        return response;
      } else if (response.data.status === 101 || response.data.status === 102) {
        localStorage.clear();
        return response;
      } else if (response.data.status === 103) {
        setSiteUnderMaintenanceOutsideReact();
      }
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

/**
 * Submits (or updates, while prediction_open) the logged-in user's answer
 * for a single general question.
 *
 * @param {string} questionId
 * @param {string} answer
 * @returns {Promise<{ data: { status: 1 | 101 | 102 | 103, message: string } }>}
 */
export const submitGeneralAnswer = (questionId, answer) => {
  return axios
    .post(url + "predict_general_answer", { general_question_id:questionId, answer }, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + `${localStorage.webKey}`,
      },
    })
    .then((response) => {
      if (response.data.status === 1) {
        return response;
      } else if (response.data.status === 101 || response.data.status === 102) {
        localStorage.clear();
        return response;
      } else if (response.data.status === 103) {
        setSiteUnderMaintenanceOutsideReact();
      }
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

/**
 * Fetches the announced correct answers for the general questions, once
 * results are published.
 *
 * SPECULATIVE — this endpoint isn't live yet; getGeneralQuestions already
 * returns `que_answer` and `winners` per-question once the backend
 * publishes them, so this may turn out to be unnecessary. Verify against
 * the backend before wiring this in.
 *
 * @param {{}} data
 * @returns {Promise<{
 *   data: {
 *     status: 1 | 101 | 102 | 103,
 *     message: string,
 *     data: {
 *       results: Array<{ question_id: string, correct_answer: string }>
 *     }
 *   }
 * }>}
 */
// NOT YET USED — speculative endpoint, unconfirmed
export const getGoldenAwardResults = (data) => {
  return axios
    .post(url + "get_golden_award_results", data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + `${localStorage.webKey}`,
      },
    })
    .then((response) => {
      if (response.data.status === 1) {
        return response;
      } else if (response.data.status === 101 || response.data.status === 102) {
        localStorage.clear();
        return response;
      } else if (response.data.status === 103) {
        setSiteUnderMaintenanceOutsideReact();
      }
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};
